$(document).ready(function(){
  //announcement slider
$('.announcement_slider').slick({
  infinite: true,
 //centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M10.2833 0C10.4021 0 10.5236 0.0469492 10.6147 0.138072C10.797 0.320318 10.797 0.618543 10.6147 0.800789L4.37683 7.04143L10.5236 13.1882C10.7058 13.3704 10.7058 13.6687 10.5236 13.8509C10.3413 14.0332 10.0431 14.0332 9.86088 13.8509L3.38278 7.3728C3.20053 7.19056 3.20053 6.89232 3.38278 6.71007L9.952 0.138086C10.0431 0.0469629 10.1646 2.73438e-05 10.2834 2.73438e-05L10.2833 0Z' fill='white'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M3.71666 0C3.59792 0 3.47641 0.0469492 3.38529 0.138072C3.20305 0.320318 3.20305 0.618543 3.38529 0.800789L9.62317 7.04143L3.47641 13.1882C3.29417 13.3704 3.29417 13.6687 3.47641 13.8509C3.65866 14.0332 3.95687 14.0332 4.13912 13.8509L10.6172 7.3728C10.7995 7.19056 10.7995 6.89232 10.6172 6.71007L4.048 0.138086C3.95687 0.0469629 3.8354 2.73438e-05 3.71664 2.73438e-05L3.71666 0Z' fill='white'/></svg></div>",
   responsive: [

    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
    //homepage testimonial
  $('.testimonal-slider').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'><path d='M31.5 15.75L20.25 27L31.5 38.25' stroke='#333333' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='54' height='54' viewBox='0 0 54 54' fill='none'><path d='M22.5 15.75L33.75 27L22.5 38.25' stroke='#333333' stroke-linecap='round' stroke-linejoin='round'/></svg></div>",
       responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

          //homepage our-collection 
$('.Categories-slider').slick({
  infinite: true,
 //centerMode: true,
  slidesToShow: 5,
  slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M25.119 11.6309C25.2004 11.7122 25.2649 11.8087 25.309 11.9149C25.353 12.0211 25.3757 12.135 25.3757 12.25C25.3757 12.365 25.353 12.4789 25.309 12.5851C25.2649 12.6913 25.2004 12.7878 25.119 12.8691L10.8631 27.125L47.25 27.125C47.4821 27.125 47.7046 27.2172 47.8687 27.3813C48.0328 27.5454 48.125 27.7679 48.125 28C48.125 28.2321 48.0328 28.4546 47.8687 28.6187C47.7046 28.7828 47.4821 28.875 47.25 28.875H10.8631L25.119 43.1309C25.2003 43.2122 25.2648 43.3087 25.3088 43.415C25.3528 43.5212 25.3755 43.635 25.3755 43.75C25.3755 43.865 25.3528 43.9788 25.3088 44.085C25.2648 44.1913 25.2003 44.2878 25.119 44.3691C25.0378 44.4504 24.9412 44.5148 24.835 44.5588C24.7288 44.6028 24.615 44.6255 24.5 44.6255C24.385 44.6255 24.2712 44.6028 24.165 44.5588C24.0587 44.5148 23.9622 44.4504 23.8809 44.3691L8.13092 28.6191C8.04957 28.5378 7.98503 28.4413 7.941 28.3351C7.89696 28.2289 7.8743 28.115 7.8743 28C7.8743 27.885 7.89696 27.7712 7.941 27.6649C7.98503 27.5587 8.04957 27.4622 8.13092 27.3809L23.8809 11.6309C23.9622 11.5496 24.0587 11.485 24.1649 11.441C24.2711 11.397 24.385 11.3743 24.5 11.3743C24.615 11.3743 24.7288 11.397 24.8351 11.441C24.9413 11.485 25.0378 11.5496 25.119 11.6309Z' fill='black'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M30.881 11.6309C30.7996 11.7122 30.7351 11.8087 30.6911 11.9149C30.647 12.0211 30.6244 12.135 30.6244 12.25C30.6244 12.365 30.647 12.4789 30.6911 12.5851C30.7351 12.6913 30.7996 12.7878 30.881 12.8691L45.1369 27.125L8.75005 27.125C8.51798 27.125 8.29542 27.2172 8.13132 27.3813C7.96723 27.5454 7.87505 27.7679 7.87505 28C7.87505 28.2321 7.96723 28.4546 8.13132 28.6187C8.29542 28.7828 8.51798 28.875 8.75005 28.875H45.1369L30.881 43.1309C30.7997 43.2122 30.7352 43.3087 30.6912 43.415C30.6472 43.5212 30.6246 43.635 30.6246 43.75C30.6246 43.865 30.6472 43.9788 30.6912 44.085C30.7352 44.1913 30.7997 44.2878 30.881 44.3691C30.9623 44.4504 31.0588 44.5148 31.165 44.5588C31.2712 44.6028 31.3851 44.6255 31.5 44.6255C31.615 44.6255 31.7289 44.6028 31.8351 44.5588C31.9413 44.5148 32.0378 44.4504 32.1191 44.3691L47.8691 28.6191C47.9505 28.5378 48.015 28.4413 48.059 28.3351C48.1031 28.2289 48.1257 28.115 48.1257 28C48.1257 27.885 48.1031 27.7712 48.059 27.6649C48.015 27.5587 47.9505 27.4622 47.8691 27.3809L32.1191 11.6309C32.0378 11.5496 31.9413 11.485 31.8351 11.441C31.7289 11.397 31.615 11.3743 31.5 11.3743C31.3851 11.3743 31.2712 11.397 31.165 11.441C31.0587 11.485 30.9622 11.5496 30.881 11.6309Z' fill='black'/></svg></div>",
   responsive: [
    {
      breakpoint: 989,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
      //homepage Our Products
$('.collection_slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
    prevArrow:"<div class='pre-btn'><svg width='54' height='54' viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M18.1575 28.2218L36.9664 46.1431C37.2802 46.4422 37.6972 46.6091 38.1307 46.6091C38.5643 46.6091 38.9813 46.4422 39.2951 46.1431L39.3154 46.1228C39.468 45.9778 39.5896 45.8032 39.6727 45.6097C39.7557 45.4162 39.7986 45.2078 39.7986 44.9972C39.7986 44.7867 39.7557 44.5783 39.6727 44.3848C39.5896 44.1913 39.468 44.0167 39.3154 43.8717L21.6034 26.9967L39.3154 10.1284C39.468 9.9834 39.5896 9.80882 39.6727 9.61532C39.7557 9.42183 39.7986 9.21345 39.7986 9.00287C39.7986 8.79229 39.7557 8.58392 39.6727 8.39042C39.5896 8.19692 39.468 8.02234 39.3154 7.87731L39.2951 7.85706C38.9813 7.55788 38.5643 7.39098 38.1307 7.39098C37.6972 7.39098 37.2802 7.55788 36.9664 7.85706L18.1575 25.7783C17.9921 25.9359 17.8604 26.1255 17.7704 26.3355C17.6804 26.5455 17.634 26.7716 17.634 27.0001C17.634 27.2285 17.6804 27.4546 17.7704 27.6646C17.8604 27.8747 17.9921 28.0642 18.1575 28.2218Z' fill='black'/></svg></div>",
    nextArrow:"<div class='next-btn'><svg width='54' height='54' viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M35.8425 28.2218L17.0336 46.1431C16.7198 46.4422 16.3028 46.6091 15.8693 46.6091C15.4357 46.6091 15.0187 46.4422 14.7049 46.1431L14.6846 46.1228C14.532 45.9778 14.4104 45.8032 14.3273 45.6097C14.2443 45.4162 14.2014 45.2078 14.2014 44.9972C14.2014 44.7867 14.2443 44.5783 14.3273 44.3848C14.4104 44.1913 14.532 44.0167 14.6846 43.8717L32.3966 26.9967L14.6846 10.1284C14.532 9.9834 14.4104 9.80882 14.3273 9.61532C14.2443 9.42183 14.2014 9.21345 14.2014 9.00287C14.2014 8.79229 14.2443 8.58392 14.3273 8.39042C14.4104 8.19692 14.532 8.02234 14.6846 7.87731L14.7049 7.85706C15.0187 7.55788 15.4357 7.39098 15.8693 7.39098C16.3028 7.39098 16.7198 7.55788 17.0336 7.85706L35.8425 25.7783C36.0079 25.9359 36.1396 26.1255 36.2296 26.3355C36.3196 26.5455 36.366 26.7716 36.366 27.0001C36.366 27.2285 36.3196 27.4546 36.2296 27.6646C36.1396 27.8747 36.0079 28.0642 35.8425 28.2218Z' fill='black'/></svg></div>",
   responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});
      //collection side bar sticky
         if (window.matchMedia("(max-width: 767px)").matches) 
        {  
          console.log('mobile');
        } else {
  $(function() {
    var top = $('.categories-card').offset().top - parseFloat($('.categories-card').css('marginTop').replace(/auto/, 0));
    var footTop = $('.footer').offset().top - parseFloat($('.footer').css('marginTop').replace(/auto/, 0));

    var maxY = footTop - $('.categories-card').outerHeight();

    $(window).scroll(function(evt) {
        var y = $(this).scrollTop();
        if (y > top) {
            
            if (y < maxY) {
                $('.categories-card').addClass('fixed').removeAttr('style');
            } else {
                $('.categories-card').removeClass('fixed').css({
                    position: 'absolute',
                    top: (maxY - top) + 'px'
                });
            }
        } else {
            $('.categories-card').removeClass('fixed');
        }
    });
});
  }
    //product page tabs
  $('ul.tabs').each(function(){
 var active, content, links = $(this).find('a');
 active = links.first().addClass('active');
 content = $(active.attr('href'));
 links.not(':first').each(function () {
 $($(this).attr('href')).hide();
 });
 $(this).find('a').click(function(e){
 active.removeClass('active');
 active.parents('.cgt-desc').find('.main-content').addClass('cgt-content');
 content.hide();
 active = $(this);
 content = $($(this).attr('href'));
 active.addClass('active');
 content.show();
 return false;
 });
  $(this).find('.reviews').click(function(e){
    $(this).parents('.cgt-desc').find('.main-content').removeClass('cgt-content');
  });
   
 });
    $('a.reviews').click(function(){

    $('.jdgm-widget.jdgm-review-widget.jdgm--done-setup-widget').show();
});
    $('a.description.active').click(function(){

    $('.jdgm-widget.jdgm-review-widget.jdgm--done-setup-widget').hide();
});
//product page slider
   $('.slider-for').slick({
     prevArrow: "<div class='product pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
   nextArrow: "<div class='product next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",  
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   fade: true,
   infinite: false,
   asNavFor: '.slider_thum'
 });
  
 $(".slider_thum").slick({
   // prevArrow: "<div class='pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
   // nextArrow:  "<div class='next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",                  
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: true,
      vertical: true,
      asNavFor: '.slider-for',
      focusOnSelect: true,
         responsive: [
 
    {
      breakpoint: 767,
      settings: {
      vertical: false,
       slidesToShow: 3,
      },
    },
  ],
   
  });
//homepage scroll
  $("#class_scrll").click(function() {
    $('html, body').animate({
        scrollTop: $("#shopify-section-template--15825029365953__0d9bff5c-bc5f-43f4-9a66-17f29e148ac5").offset().top
    }, 1000);
    return false;
});
})